import { useTranslation } from "react-i18next";

const UserAccessHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (!onSort) return;
    if (sortByField === field) {
      onSort(field, orderSortByField === "1" ? "-1" : "1");
    } else {
      onSort(field, "1");
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("lastName")}
      >
        {t("User name")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("lastName")}`} aria-hidden />
        </span>
      </div>
      <div className="table-standard-header-cell">{t("Related addresses")}</div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("email")}
      >
        {t("Email")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("email")}`} aria-hidden />
        </span>
      </div>
      <div className="table-standard-header-cell">{t("Phone")}</div>
    </article>
  );
};

export default UserAccessHeader;
